
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('favorites', ['favorites']),
    ...mapGetters('favorites', ['isOpen']),
    // ...mapGetters('cart', ['products']),
  },

  mounted() {
    this.$store.dispatch('favorites/getFavorites')
  },

  methods: {
    closeFavorites() {
      this.$store.commit('favorites/setClose')
    },
  },
}
